// extracted by mini-css-extract-plugin
export default {"container":"GEehv","aside":"cFeTz","body":"JczQy","content":"vxPkn","footer":"CtIsv","actionBarIsSwitch":"QwK0R","unsubscribe":"kyFRZ"};